import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemBase } from '../list-row-item-base';

@Component({
    selector: 'fi-items-list-row-item-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemEmailComponent extends ItemsListRowItemBase {}
